import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=4c0c5795&"
import script from "./OrderInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports